export class Rule<T> {
    info: any;

    constructor(public id: string,
        public message: string,
        public entity: T) {
    }
}
